import PaymentPlan from './PaymentPlan';

export default PaymentPlan;
